import FontAwesome from './fontawesome-icons';
export { FontAwesome };
